var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowFileImage
    ? _c("div", { staticClass: "show-big-image" }, [
        _c("img", {
          staticClass: "prev-image",
          attrs: { src: _vm.prevImage, alt: "" },
          on: { click: _vm.prevFunc },
        }),
        _c("img", {
          staticClass: "next-image",
          attrs: { src: _vm.nextImage, alt: "" },
          on: { click: _vm.nextFunc },
        }),
        _vm.bigImage
          ? _c("div", { staticClass: "show-image-content" }, [
              _c("span", { staticClass: "show-image-name" }, [
                _vm._v(_vm._s(_vm.curFile.name)),
              ]),
              _c("img", {
                staticClass: "show-image",
                attrs: { src: _vm.bigImage, alt: "" },
              }),
            ])
          : _vm._e(),
        !_vm.bigImage
          ? _c(
              "a",
              {
                staticClass: "show-image show-file",
                attrs: { href: _vm.fileUrl, target: "_blank" },
              },
              [_vm._v(_vm._s(_vm.curFile.name))]
            )
          : _vm._e(),
        _c("img", {
          staticClass: "close-image",
          attrs: { src: _vm.closeImage, alt: "" },
          on: { click: _vm.close },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }